// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_in-0";
export var optionCard = "_in-1";